import type { ReactNode } from 'react'
import { usePrivacy } from '../lib/privacy.js'

interface Props {
  /** What to render when privacy is OFF — typically a formatted amount. */
  children: ReactNode
  /** Fixed-width placeholder shown when privacy is ON. Defaults to "***".
   *  Width-preserving placeholders (matching the length of `children`) defeat
   *  the purpose because the blurred width itself leaks magnitude — pick a
   *  short fixed string like `$***,***` or `**%`. */
  as?: string
}

/**
 * Privacy-aware substitute. When the screencast/privacy mode is on, swaps
 * `children` for a fixed-width placeholder so observers can't read magnitude
 * through layout. Use this instead of the `[data-mask]` CSS-blur escape
 * hatch wherever the rendered value is a number — blur preserves character
 * widths and a $1.2M amount is visibly wider than $12.
 */
export function Mask({ children, as = '***' }: Props) {
  const privacy = usePrivacy()
  return <>{privacy ? as : children}</>
}
